import moment from "moment";
import loader from "./loader";
// import _ from 'lodash'
import secureStorage from "libraries/secureStorage";
import getinfo from "helper/getinfo";

const receipt = (payload) => {
  const printer = secureStorage.getItem("printer");
  const user = secureStorage.getItem("account");
  const info = secureStorage.getItem("domainInfo");
  const title = `${payload.title.padStart(105, " ")}\r\n`;
  const body = payload.body;

  const isOriginal = payload.isOriginal ? true : false;
  const reference = body.reference || body.referenceNo;
  const date = body.date && body.date.value ? body.date.value : payload.createdAt;

  // console.log({ date, payload });
  const leftPage = [
    ["TGL", moment(date).format("DD/MM/YY HH:mm")],
    ["NOPEL", body.customerNo.value],
    // ["IDLAIN", body.otherCustomerId.value],
    ["NAMA", body.name.value],

    ["PERIOD", body.dueDate.value],
    ["JMLTAG", body.qty.value],

    ["RP TAG", body.amount.value],
    ["ADMIN", body.admin.value],
    ["BAYAR", body.total.value],
  ];

  for (let i = leftPage.length; i < 11; i++) leftPage.push([""]);

  const middlePage = [
    ["TANGGAL", moment(date).format("DD/MM/YY HH:mm")],
    ["NOPEL", body.customerNo.value],
    // ["IDLAIN", body.otherCustomerId.value],
    ["NAMA", body.name.value],

    [body.divre.caption, body.divre.value],
    [body.datel.caption, body.datel.value],
    ["AREA", body.area.value],

    ...getinfo(body.info.value),
  ];

  printer === "dotmatrix"
    ? middlePage.push([`${String.fromCharCode(27)}4Loket : ${user.name}`])
    : middlePage.push([`Loket : ${user.name}`]);
  printer === "dotmatrix"
    ? middlePage.push([`Powered by ${payload.appName}${String.fromCharCode(27)}5`])
    : middlePage.push([`${isOriginal ? "ASLI :" : "COPY :"} Powered by ${payload.appName}`]);

  for (let i = middlePage.length; i < 11; i++) middlePage.push([""]);

  const rightPage = [
    [body.dueDate.caption, body.dueDate.value],
    [reference.caption, reference.value.toString().substring(0, 15)],
    [body.qty.caption, body.qty.value],
    [body.amount.caption, body.amount.value],
    [body.admin.caption, body.admin.value],
    [body.total.caption, body.total.value],
  ];
  for (let i = rightPage.length; i < 11; i++) rightPage.push([""]);

  if (printer === "dotmatrix") return loader(title, leftPage, middlePage, rightPage, payload);
  else return { title, leftPage, middlePage, rightPage, payload };
};
export default receipt;
